
document.addEventListener('DOMContentLoaded', function() {
  var root = document.querySelector('#jins-today-essential');
  var cdnBase = 'https://cdn.shopify.com/s/files/1/0562/8903/4283/files/';
  if (!root) return;

  var isMobile = window.innerWidth < 769;
  window.addEventListener('resize', function() { isMobile = window.innerWidth < 769; });

  /* ── Product Carousels (5 instances) ── */
  var productSliders = {};

  function initProductSlider(el) {
    var id = el.id || el.dataset.id;
    var track = el.querySelector('.jt-te-product-slider__track');
    var slides = el.querySelectorAll('.jt-te-product-slider__slide');
    var prevBtn = el.querySelector('.jt-te-product-arrow--prev');
    var nextBtn = el.querySelector('.jt-te-product-arrow--next');
    var slideCount = slides.length;
    if (!track || slideCount === 0) return;

    var current = 0;

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.setAttribute('data-disabled', String(current <= 0));
      nextBtn.setAttribute('data-disabled', String(current >= slideCount - 1));
    }

    function goTo(index) {
      current = Math.max(0, Math.min(index, slideCount - 1));
      if (isMobile) {
        var slide = slides[current];
        if (slide) {
          track.scrollTo({
            left: slide.offsetLeft - (track.offsetWidth - slide.offsetWidth) / 2,
            behavior: 'smooth'
          });
        }
      } else {
        /* Desktop: slide into view, cap at end */
        var perView = 1440 / 410; /* ~3.51 slides visible */
        var slideW = 100 / perView;
        var maxPct = Math.max(0, (slideCount - perView) * slideW);
        var pct = current * slideW;
        track.style.transform = 'translateX(-' + Math.min(pct, maxPct) + '%)';
      }
      updateArrows();
    }

    /* Arrow click handlers */
    if (prevBtn) prevBtn.addEventListener('click', function(e) { e.stopPropagation(); goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(e) { e.stopPropagation(); goTo(current + 1); });

    /* Mobile scroll sync */
    if (isMobile) {
      var scrollTimer;
      track.addEventListener('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          var center = track.scrollLeft + track.offsetWidth / 2;
          var closest = 0, dist = Infinity;
          slides.forEach(function(s, i) {
            var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - center);
            if (d < dist) { dist = d; closest = i; }
          });
          current = closest;
          updateArrows();
        }, 50);
      });
    }

    productSliders[id] = { el: el, goTo: goTo, getCurrent: function() { return current; } };
    goTo(0);
  }

  root.querySelectorAll('.jt-te-product-slider').forEach(function(el) {
    var obs = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) { initProductSlider(el); obs.disconnect(); }
    }, { rootMargin: '200px 0px', threshold: 0 });
    obs.observe(el);
  });

  /* ── Modal System ── */
  root.querySelectorAll('.modal').forEach(function(modal) {
    var track = modal.querySelector('.jt-te-modal-slider__track');
    var slides = modal.querySelectorAll('.jt-te-modal-slider__slide');
    var prevBtn = modal.querySelector('.modal_button-prev');
    var nextBtn = modal.querySelector('.modal_button-next');
    var closeBtns = modal.querySelectorAll('.js-close-modal');
    var modalId = modal.id;
    var current = 0;
    var slideCount = slides.length;

    /* Move close button out of overflow:hidden container */
    var closeBtn = modal.querySelector('.modal_close');
    if (closeBtn && closeBtn.parentNode !== modal) {
      modal.appendChild(closeBtn);
    }

    /* Position close button below modal card dynamically */
    function positionClose() {
      if (!closeBtn) return;
      var card = modal.querySelector('.modal_content');
      if (!card) return;
      var cardRect = card.getBoundingClientRect();
      var gap = 16;
      var idealTop = cardRect.bottom + gap;
      var maxTop = window.innerHeight - 40; /* Never closer than 40px from bottom */
      closeBtn.style.top = Math.min(idealTop, maxTop) + 'px';
      closeBtn.style.bottom = 'auto';
      closeBtn.style.left = '50%';
      closeBtn.style.transform = 'translateX(-50%)';
    }

    function modalGoTo(index) {
      current = Math.max(0, Math.min(index, slideCount - 1));
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      if (prevBtn) prevBtn.style.opacity = current <= 0 ? '0' : '1';
      if (prevBtn) prevBtn.style.pointerEvents = current <= 0 ? 'none' : 'auto';
      if (nextBtn) nextBtn.style.opacity = current >= slideCount - 1 ? '0' : '1';
      if (nextBtn) nextBtn.style.pointerEvents = current >= slideCount - 1 ? 'none' : 'auto';
    }

    function openModal(slideIndex) {
      modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      document.documentElement.classList.add('is-clipped');
      modalGoTo(slideIndex);
      setTimeout(positionClose, 50);
      /* Hide sticky nav while modal is open */
      var stickyNav = root.querySelector('.jt-te-cat-slider.is-sticky');
      if (stickyNav) stickyNav.style.display = 'none';
    }

    function closeModal() {
      modal.classList.remove('is-active');
      document.body.style.overflow = '';
      document.documentElement.classList.remove('is-clipped');
      /* Restore sticky nav */
      var stickyNav = root.querySelector('.jt-te-cat-slider');
      if (stickyNav) stickyNav.style.display = '';
    }

    /* Bind open triggers */
    var triggers = document.querySelectorAll('[data-modal="' + modalId + '"]');
    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var idx = Number(trigger.dataset.slideIndex || 0);
        openModal(idx);
      });
    });

    /* Bind close */
    closeBtns.forEach(function(btn) {
      btn.addEventListener('click', closeModal);
    });

    /* Bind prev/next */
    if (prevBtn) prevBtn.addEventListener('click', function() { modalGoTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { modalGoTo(current + 1); });

    /* Keyboard nav */
    modal.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft') modalGoTo(current - 1);
      if (e.key === 'ArrowRight') modalGoTo(current + 1);
    });

    /* Reposition close on resize */
    window.addEventListener('resize', function() {
      if (modal.classList.contains('is-active')) positionClose();
    });
  });

  /* ── Category Pill Text Fix (inline styles beat all CSS) ── */
  root.querySelectorAll('.style_categoryText p').forEach(function(p) {
    p.style.cssText = 'text-align: center !important; margin: 0 !important; padding: 0 !important;';
  });
  root.querySelectorAll('.style_categoryText').forEach(function(el) {
    el.style.cssText = 'display: flex !important; align-items: center !important; justify-content: center !important;';
  });
  /* Hide thumbnail rotators so they don't take up space */
  root.querySelectorAll('.style_anchorLink .jt-te-cat-thumb-rotator').forEach(function(el) {
    el.style.cssText = 'display: none !important;';
  });
  /* Center the anchor link content */
  root.querySelectorAll('.style_anchorLink').forEach(function(el) {
    el.style.cssText += 'justify-content: center !important; padding-left: 16px !important; padding-right: 16px !important;';
  });

  /* ── Category Thumbnail Rotation ── */
  root.querySelectorAll('.jt-te-cat-thumb-rotator').forEach(function(rotator) {
    var imgs = rotator.querySelectorAll('.jt-te-cat-thumb-rotator__img');
    if (imgs.length <= 1) return;
    var current = 0;
    imgs[0].classList.add('is-active');

    var randomDelay = Math.random() * 4000;
    setTimeout(function() {
      setInterval(function() {
        imgs[current].classList.remove('is-active');
        current = (current + 1) % imgs.length;
        imgs[current].classList.add('is-active');
      }, 1000);
    }, randomDelay);
  });

  /* ── Marquee Builder ── */
  (function() {
    var styleData = [
      { img: 'jins-today-ess-style01.webp', slider: 'jt-te-slider-0', slide: 0 },
      { img: 'jins-today-ess-style02.webp', slider: 'jt-te-slider-0', slide: 1 },
      { img: 'jins-today-ess-style03.webp', slider: 'jt-te-slider-0', slide: 2 },
      { img: 'jins-today-ess-style04.webp', slider: 'jt-te-slider-0', slide: 3 },
      { img: 'jins-today-ess-style05.webp', slider: 'jt-te-slider-0', slide: 4 },
      { img: 'jins-today-ess-style06.webp', slider: 'jt-te-slider-1', slide: 0 },
      { img: 'jins-today-ess-style07.webp', slider: 'jt-te-slider-1', slide: 1 },
      { img: 'jins-today-ess-style08.webp', slider: 'jt-te-slider-1', slide: 2 },
      { img: 'jins-today-ess-style09.webp', slider: 'jt-te-slider-1', slide: 3 },
      { img: 'jins-today-ess-style10.webp', slider: 'jt-te-slider-1', slide: 4 },
      { img: 'jins-today-ess-style11.webp', slider: 'jt-te-slider-2', slide: 0 },
      { img: 'jins-today-ess-style12.webp', slider: 'jt-te-slider-2', slide: 1 },
      { img: 'jins-today-ess-style13.webp', slider: 'jt-te-slider-2', slide: 2 },
      { img: 'jins-today-ess-style15.webp', slider: 'jt-te-slider-2', slide: 4 },
      { img: 'jins-today-ess-style16.webp', slider: 'jt-te-slider-3', slide: 0 },
      { img: 'jins-today-ess-style17.webp', slider: 'jt-te-slider-3', slide: 1 },
      { img: 'jins-today-ess-style18.webp', slider: 'jt-te-slider-3', slide: 2 },
      { img: 'jins-today-ess-style19.webp', slider: 'jt-te-slider-3', slide: 3 },
      { img: 'jins-today-ess-style20.webp', slider: 'jt-te-slider-3', slide: 4 },
      { img: 'jins-today-ess-style21.webp', slider: 'jt-te-slider-4', slide: 0 },
      { img: 'jins-today-ess-style22.webp', slider: 'jt-te-slider-4', slide: 1 },
      { img: 'jins-today-ess-style23.webp', slider: 'jt-te-slider-4', slide: 2 },
      { img: 'jins-today-ess-style22.webp', slider: 'jt-te-slider-4', slide: 1 }
    ];

    /* Shuffle */
    for (var i = styleData.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = styleData[i];
      styleData[i] = styleData[j];
      styleData[j] = temp;
    }

    var lists = root.querySelectorAll('.style_list');
    var perCol = 7;
    var groups = [
      styleData.slice(0, perCol),
      styleData.slice(perCol, perCol * 2),
      styleData.slice(perCol * 2, perCol * 3)
    ];

    lists.forEach(function(list, idx) {
      if (!groups[idx]) return;
      groups[idx].forEach(function(item) {
        var li = document.createElement('li');
        li.classList.add('style_item');
        li.dataset.slider = item.slider;
        li.dataset.slide = item.slide;
        li.innerHTML = '<img src="' + cdnBase + item.img + '" alt="" loading="lazy">';
        list.appendChild(li);
      });
    });

    /* Click handler: scroll to product section + slide */
    document.addEventListener('click', function(e) {
      var item = e.target.closest('.style_item');
      if (!item) return;
      var sliderId = item.dataset.slider;
      var slideIdx = Number(item.dataset.slide);
      var target = document.getElementById(sliderId);
      if (!target) return;
      var offset = isMobile ? 170 : 220;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
      setTimeout(function() {
        var slider = productSliders[sliderId];
        if (slider) slider.goTo(slideIdx);
      }, 400);
    });
  })();

  /* ── fadeIn IntersectionObserver ── */
  var fadeObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting && entry.target.classList.contains('fadeIn')) {
        setTimeout(function() { entry.target.classList.add('is-active'); }, 200);
      }
    });
  }, { threshold: 0.5 });
  root.querySelectorAll('.fadeIn').forEach(function(el) { fadeObserver.observe(el); });

  /* ── Anchor Smooth Scroll ── */
  root.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      if (!link.classList.contains('smooth-scroll')) return;
      var href = link.getAttribute('href');
      if (!href || href === '#') return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      var offset = isMobile ? 0 : 100;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  /* ── Scroll Position Persistence ── */
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  root.querySelectorAll('.js-ec-link').forEach(function(el) {
    el.addEventListener('click', function() {
      sessionStorage.setItem('jt-te-scroll-pos', window.scrollY);
      sessionStorage.setItem('jt-te-return', 'true');
    });
  });
  window.addEventListener('pageshow', function(e) {
    var flag = sessionStorage.getItem('jt-te-return');
    var pos = sessionStorage.getItem('jt-te-scroll-pos');
    if ((e.persisted || (performance.getEntriesByType('navigation')[0] || {}).type === 'back_forward') && flag && pos !== null) {
      setTimeout(function() { window.scrollTo(0, parseInt(pos, 10)); }, 80);
    }
    sessionStorage.removeItem('jt-te-scroll-pos');
    sessionStorage.removeItem('jt-te-return');
  });

  /* ── Sticky Category Nav ── */
  (function() {
    var catSlider = root.querySelector('.jt-te-cat-slider');
    var styleSection = root.querySelector('.style');
    var seasonal = root.querySelector('.seasonal');
    if (!catSlider || !styleSection) return;

    var headerHeight = 72; /* Dawn header */
    var isSticky = false;
    var placeholder = document.createElement('div');
    placeholder.style.display = 'none';

    function onScroll() {
      var styleBottom = styleSection.getBoundingClientRect().bottom;
      var seasonalTop = seasonal ? seasonal.getBoundingClientRect().top : Infinity;
      var catHeight = catSlider.offsetHeight;

      var shouldStick = styleBottom <= headerHeight && seasonalTop > (headerHeight + catHeight + 20);

      if (shouldStick && !isSticky) {
        placeholder.style.height = catHeight + 'px';
        placeholder.style.display = 'block';
        catSlider.parentNode.insertBefore(placeholder, catSlider);
        catSlider.classList.add('is-sticky');
        isSticky = true;
      } else if (!shouldStick && isSticky) {
        catSlider.classList.remove('is-sticky');
        placeholder.style.display = 'none';
        isSticky = false;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();
});
